import moment from 'moment';
import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { getArticle } from '../../actions/ArticleAction';
import { l10n } from '../../i18n/Localization';
import DateTimeHelper from '../../utils/DateTimeHelper';
import BackButton from '../BackButton';

class ArticlePage extends Component {
    componentDidMount() {
        let articleId = this.props.articleId;
        if (articleId) {
            this.props.getArticle(articleId);
        }
    }

    render() {
        const { article } = this.props;

        let head;
        let content;

        if (article !== null) {
            head = (
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content={article.title} />
                    <title>{article.title} - {l10n.productName}</title>
                </Helmet>
            );

            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-between mb-3">
                        <BackButton disabled={false} />
                    </div>
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-9 mb-3">
                            <div>
                                <h1>{article.title}</h1>
                                <div className="text-secondary">{moment(DateTimeHelper.convertISO8601StringToDate(article.updatedAt)).calendar()}</div>
                            </div>
                            <div className="mt-3" dangerouslySetInnerHTML={{ __html: article.content }}></div>
                        </div>
                    </div>
                </div>
            );
        } else {
            head = (
                <Helmet>
                    <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
                    <meta name="description" content="Loading article" />
                    <title>{l10n.articlePage.pageTitle} - {l10n.productName}</title>
                </Helmet>
            );

            content = (
                <div className="container mt-3">
                    <div className="d-flex justify-content-center">
                        <div className="spinner-border"></div>
                    </div>
                </div>
            );
        }

        return (
            <div className="ArticlePage">
                {head}
                {content}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    let articleId = ownProps.match.params.articleId;

    return {
        articleId: articleId,
        article: state.articleState.article,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getArticle: (articleId) => {
            dispatch(getArticle(articleId));
        },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ArticlePage);
